var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18.5645 18.2324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 18.2324,
    opacity: 0,
    width: 18.5645,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 13.1543C7.87109 16.0352 11.3086 18.2227 14.0723 18.2227C15.3711 18.2227 16.5039 17.7051 17.2461 16.875C17.959 16.0742 18.2031 15.4785 18.2031 14.9512C18.2031 14.541 17.9492 14.1602 17.3047 13.7109L14.9219 12.002C14.3262 11.582 14.0625 11.5039 13.7109 11.5039C13.4082 11.5039 13.1543 11.5625 12.6465 11.8359L11.084 12.6953C10.8984 12.8027 10.8203 12.8223 10.6836 12.8223C10.498 12.8223 10.3711 12.7734 10.1855 12.6953C9.44336 12.3535 8.39844 11.5332 7.4707 10.6055C6.54297 9.67773 5.82031 8.73047 5.44922 7.99805C5.40039 7.90039 5.3418 7.74414 5.3418 7.58789C5.3418 7.46094 5.41016 7.35352 5.48828 7.2168L6.40625 5.64453C6.66016 5.21484 6.72852 4.98047 6.72852 4.64844C6.72852 4.26758 6.60156 3.85742 6.24023 3.33984L4.59961 1.05469C4.13086 0.400391 3.7793 0 3.25195 0C2.59766 0 1.80664 0.498047 1.24023 1.04492C0.429688 1.82617 0 2.91992 0 4.15039C0 6.93359 2.13867 10.3027 5 13.1543Z",
    fill: "#ffffff",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4f7fa2bba482061dcb23268c5e79eb1b.svg";
export { ForwardRef as ReactComponent };